import { Download } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { downloadLog } from '../api';
import type { LogFilters } from '../api-types';

/** «Scarica CSV»: the log with the filters in force, the way the closings' download works. */
export function DownloadButton({ filters }: { readonly filters: LogFilters }) {
  const { t } = useTranslation('communications');
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const run = async () => {
    setBusy(true);
    setFailed(false);
    const done = await downloadLog(filters);
    setBusy(false);
    setFailed(!done);
  };
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        type="button"
        variant="outline"
        className="min-h-11 @min-[620px]/shell:min-h-[38px]"
        disabled={busy}
        onClick={() => void run()}
      >
        <Download />
        {t('log.download')}
      </Button>
      {failed ? (
        <span role="alert" className="text-destructive text-sm">
          {t('log.downloadFailed')}
        </span>
      ) : null}
    </div>
  );
}
